import { render, staticRenderFns } from "./IncidentsReport.vue?vue&type=template&id=32fffdcd&"
import script from "./IncidentsReport.vue?vue&type=script&lang=js&"
export * from "./IncidentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports